// extracted by mini-css-extract-plugin
export default {"nav":"sidebar_nav__JPMt4"};